/* FRONT PAGE SCRIPTS */

jQuery(document).ready(function($) {	
	//initPreloaderScreen();
	initSliders();	
	initHellobar();	
	reviewsStars();
	addCirclesToImage();
	//triggerHandwrittingANimation();
	initScrollMagic(true);	
});

var controller,
timeline = null,
ourScene = null,
enableTween = true;

function initPreloaderScreen() {
	setTimeout(function(){
		jQuery('.home #loader').addClass('animated zoomOut');		
	}, 500);
	setTimeout(function(){		
		jQuery('.home #loader-wrapper').fadeOut('slow');	
		jQuery('.home .off-canvas-wrapper').css('opacity', 1);
	}, 1050);
	initSubmenus();
}


function initSubmenus() {
	jQuery('.top-bar #menu-topnav-1').css('opacity',1);	
/*	setTimeout(function(){
		jQuery('.top-bar .fixedlogo').css('display','block').addClass('animated fadeInLeft');
	}, 800); */
}

function addCirclesToImage(){
	var imageTarget = jQuery('.hp-second-services .hp-second-services-img-column .wp-block-image');
	
	var circleTopLeft = '<div class="circle floating-circle-top-left fp-magic-scroll"></div>';
	var circleBottomRight = '<div class="circle floating-circle-bottom-right fp-magic-scroll"></div>';
	
	imageTarget.prepend(circleTopLeft);
	imageTarget.append(circleBottomRight);
	
	
}

function triggerHandwrittingANimation(){
	//console.log("Inside function");
	jQuery(window).scroll(function () {
		//console.log("Inside scroll");
		jQuery('.footer #svgwrapper ').each(function () {
			//console.log("Inside svgwrapper");
			var imagePos = jQuery('.footer #svgwrapper ').offset().top - 600;
			var imageHeight = jQuery(this).height() + 100;
			var topOfWindow = jQuery(window).scrollTop();
			//console.log(imagePos);
			//console.log(imageHeight);
			//console.log(topOfWindow);
			//console.log(topOfWindow + imageHeight);
			
			if (imagePos < topOfWindow + imageHeight && imagePos + imageHeight > topOfWindow) {
				//console.log("Inside if");
				jQuery(this).addClass("letter-animation");
			} else {
				//console.log("Inside else");
				jQuery(this).removeClass("letter-animation");
			}
		});
	});
}


function initSliders(){	
	/* https://swiperjs.com/get-started/  */

	var fpcarouselinner = jQuery('.fp-carousel-row-inner');
	if(fpcarouselinner.length) {  
	  var mySwiper = new Swiper ('.fp-carousel-row-inner' , {
	    // Optional parameters
	    direction: 'horizontal',
	    loop: true,
	    autoHeight: true,
	    slidesPerView: 1,
		spaceBetween: 10,
	
	    // If we need pagination
	    pagination: {
	      el: '.swiper-pagination',
	      clickable: true,
	      type: 'bullets',
	      	      
	    },
	
	    // Navigation arrows
	    navigation: {
	      nextEl: '.swiper-button-next',
	      prevEl: '.swiper-button-prev',
	    },
	
	    // And if we need scrollbar
	    scrollbar: {
	      el: '.swiper-scrollbar',
	      draggable: true,
	    },
	  })
	}
}	

function initHellobar(){
	var helloBarContainer = jQuery('#hello-bar-main');
	if(helloBarContainer.length){
		jQuery('#hello-bar-close-btn').click(function() {
		 helloBarContainer.animate({
			  maxHeight: '0',
			  opacity: '0',
			  padding: '0',
			});
		});	
	}
}

// VIDEO FOR FRONT PAGE
function initHpVideo() {		
			var isTouchDevice = /Windows Phone/.test(navigator.userAgent) || ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
		
	jQuery('.banner-wrapper .video').each(function() {
		var holder = jQuery(this);
		var video = holder.find('video');
		var isDesktop = jQuery(document).width() < 1025 ? true : false; 
		
		if (isTouchDevice && isDesktop) {
			video.remove();
			jQuery(".banner-wrapper .video").addClass("mobile");
			jQuery(".banner-wrapper .video").removeClass("desktop");
		} else {
			jQuery(".banner-wrapper .video").addClass("desktop");
		}
	});
}

function reviewsStars() {	
	 jQuery('.stars').html( "<i class='fa fa-star'></i><i class='fa fa-star'></i><i class='fa fa-star'></i><i class='fa fa-star'></i><i class='fa fa-star'></i>" );
}

function initScrollMagic(active){ 
	var fpScroll = jQuery('.fp-magic-scroll');
	controller = new ScrollMagic.Controller();
			if(fpScroll.length) { 

			fpScroll.each(function(){ 			
				//console.dir(this);
				var parallaxTl = new TimelineMax(),
				dataDuration = jQuery(this).attr('data-msduration'),
				dataDistance = jQuery(this).attr('data-msdistance'),
				dataOffsets = jQuery(this).attr('data-msoffset'),
				dataDur,
				dataDis,
				dataOffset,
				invertedDataDis;
				
				if(!dataDuration) { dataDur = "100%" } else { dataDur = dataDuration;  }
				if(!dataDistance) { dataDis = 100 } else { dataDis = dataDistance;  }
				if(!dataOffsets) { dataOffset = 0  }  else { dataOffset = dataOffsets;  }
				if(Math.sign(dataDistance) == 1) {
					invertedDataDis = -Math.abs(dataDistance);
				} else if (Math.sign(dataDistance) == -1) {
					invertedDataDis = Math.abs(dataDistance);
				}
				
			
				
				parallaxTl
				.from(this, 3, {y:dataDis, ease:Power0.easeInOut}).to(this, 3, {y:invertedDataDis, ease:Power0.easeInOut});
					
				var ourScene = new ScrollMagic.Scene({
					triggerElement:this,
					triggerHook: 0.8,
					duration: dataDur,				
				})
				.offset(dataOffset)
				.setTween(parallaxTl)				
				//.addIndicators()
				.addTo(controller);				
			});							
		}
	
}

function initSwitchScrollMagic(active) {
	var divParallax = jQuery('.fp-magic-scroll');
	if (active) {
		controller.enabled(true);
	} else {
		controller.enabled(false);
			if(divParallax.length) {  
				divParallax.each(function(){ 	
					jQuery(this).css("transform","");
					jQuery(this.children[0]).css("transform","");
					
				});
			}
	}				
	controller.update(true);
	
}